















import Vue from 'vue';
import dateFormat from 'dateformat';

export default Vue.extend({
    name: 'HelloWorld',
    props: {
        data: Object,
        isDetailable: Boolean,
    },
    methods: {
        formatDateAssigned(value: string) {
            const date = new Date(value);
            return dateFormat(date, 'dd.mm.yyyy HH:MM');
        },
    },
    computed: {
        isBoolean(): boolean {
            return typeof this.data.value === 'boolean';
        },
        drowIcon(): boolean {
            return this.isBoolean && (this.data.value as boolean);
        },
        cellText(): any {
            if (this.isBoolean) {
                return '';
            }
            if (this.data.field.isDatetime) {
                return this.formatDateAssigned(this.data.value);
            }
            return this.data.value;
        },
        roteteArrow(): boolean {
            return this.data['detailsShowing'];
        },
    },
});
